import { ThrowStmt } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { SenaceService } from 'src/app/services/senace.service';
// import { IDatoProyectoDescripcionComponentePrincipal } from 'src/app/interface/interfaces';

@Component({
  selector: 'app-descripcion-proyecto',
  templateUrl: './descripcion-proyecto.component.html',
  styleUrls: ['./descripcion-proyecto.component.css']
})
export class DescripcionProyectoComponent implements OnInit {
  siglaExpediente: any;

  // derechos conseciones
  componenteDerechosConseciones = {
    titulo: 'DERECHOS Y/O CONCESIONES VINCULADAS AL PROYECTO',
    cabecera: ['Codigo', 'Fecha Formulacion', 'Fecha Vigencia', 'Nombre', 'Situacion', 'Titular'],
    filas: []
  };

  // Estudios Previos Aprobados
  componenteEstudioPrevioAprobado = {
    titulo: 'ESTUDIOS PREVIOS APROBADOS',
    cabecera: ['Entidad', 'Escrito', 'Fecha', 'Proyecto', 'Resolución Aprueba', 'Tipo Estudio'],
    filas: []
  };
  // Permisos Vigentes
  componentePermisoVigente = {
    titulo: 'PERMISOS VIGENTES',
    cabecera: ['Descripción', 'Entidad', 'Fecha', 'Nro Documento', 'Tipo Permiso'],
    filas: []
  };
  // Componentes Principales
  componentePrincipal = {
    titulo: 'COMPONENTES PRINCIPALES',
    cabecera: ['Tipo Componente', 'Componente Principal', 'Nombre Componente', 'Estado', 'Area Ocupado'],
    filas: []
  };
  // Empleo
  componenteEmpleo = {
    titulo: 'EMPLEO',
    cabecera: ['Etapa', 'Tipo Empleo', 'Cantidad', ' Calificada', 'No Calificada', '% Hombre', '% Local', '% Mujeres', '% Foráneo'],
    filas: []
  };
  // Insumos
  componenteInsumo = {
    titulo: 'INSUMOS',
    cabecera: ['Insumo', 'Cantidad', ' Frecuencia', 'Unidad'],
    filas: []
  };
  // Uso de Agua
  componenteUsoAgua = {
    titulo: 'USO DE AGUA',
    cabecera: ['Nombre fuente', 'Tipo Uso', 'Descripción', 'Consumo Actual', 'Nro Días', 'Total', 'Fuente Abastecimiento', 'Norte', 'Este', 'Zona'],
    filas: []
  };
  // Efluentes
  componenteEfluentes = {
    titulo: 'EFLUENTES',
    cabecera: ['Código', 'Descripción', 'Este', 'Norte', 'Zona', 'Caudal', 'Accesibilidad', 'Unidad Medida', 'Frecuencia'],
    filas: []
  };
  // Residuos a extraer
  componenteResiduosEExtraer = {
    titulo: 'RECURSO EXTRAER',
    cabecera: ['Tipo Recurso', 'Descripción', 'Recurso', 'Cantidad', 'Unidad Medida', 'Frecuencia'],
    filas: []
  };
  // Residuos a generar
  componenteResiduosGenerar = {
    titulo: 'RESIDUOS A GENERAR',
    cabecera: ['Clasificación', 'Tipo Residuo', 'Unidad Peso', 'Peso', 'Frecuencia', 'Volumen'],
    filas: []
  };
  // Manejo residuos peligrosos
  componenteManejoResiduosPeligrosos = {
    titulo: 'MANEJO DE RESIDUOS PELIGROSOS',
    // cabecera: ['Almacenaje Temporal', 'Comercialización', 'Reprovechamiento', 'Minimización', 'Manejo Total', 'Empresa Comercializadora', 'Empresa Prestadora de Servicios', 'Clasificación'],
    cabecera: ['Tipo Residuo', 'Almacenaje Temporal', 'Comercialización', 'Reprovechamiento', 'Minimización', 'Manejo Total', 'Empresa Comercializadora', 'Empresa Prestadora de Servicios', 'Clasificación'],
    filas: []
  };
  // Manejo residuos peligrosos
  componenteTratamientoResiduosPeligrosos = {
    titulo: 'TRATAMIENTO DE RESIDUOS PELIGROSOS',
    cabecera: ['Tipo de Residuos', 'Cantidad', 'Descripción', 'Observación', 'Empresa Prestadora Servicios', 'Clasificación'],
    filas: []
  };
  // Recursos Naturales
  componenteRecursosNaturales = {
    titulo: 'RECURSOS NATURALES',
    cabecera: ['Cantidad', 'Descripción', 'Frecuencia', 'Recurso Natural', 'Unidad Medida'],
    filas: []
  }
  // Etapas de proyecto
  componenteEtapasProyecto = {
    titulo: 'ETAPAS DEL PROYECTO',
    cabecera: ['Etapas', 'Descripción', 'Mes Inicio', 'Mes Fin', 'Total Meses'],
    filas: []
  }
  // Superficies
  componenteSuperficies = {
    titulo: 'SUPERFICIES',
    cabecera: ['Titularidad', 'Superficie HA', 'Situación Predio', 'Destino'],
    filas: []
  }
  // Antecedentes ( Solo para ITS )
  componenteAntecedentes = {
    titulo: 'ANTECEDENTES',
    cabecera: ['Tipo de IGA', 'Resolución', 'Fecha RD'],
    filas: []
  }





  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) { }

  ngOnInit() {
    this.localStorage.getItem('detalle').subscribe(
      (resp: any) => {
        if (resp.correlativo) {
          this.siglaExpediente = resp.correlativo.split('-')[1];
        }
        this.getComponenteDerechoConsecion(resp);
        this.getComponenteEstudioPrevioAprobado(resp);
        this.getComponentePermisoVigente(resp);
        this.getComponentePrincipal(resp);
        this.getComponenteEmpleo(resp);
        this.getComponenteInsumo(resp);
        this.getComponenteUsoAgua(resp);
        this.getComponenteEfluente(resp);
        this.getComponenteResiduosAExtraer(resp);
        this.getComponenteResiduosGenerar(resp);
        this.getComponenteResiduosPeligrosos(resp);
        this.getComponenteTratamientoResiduosPeligrosos(resp);
        this.getComponenteRecursoNatural(resp);
        this.getComponenteEtapasProyecto(resp);
        this.getComponenteSuperficies(resp);
        this.getAntecedentesIGA(resp);
      }
    )
  }

  getComponenteDerechoConsecion(resultado) {
    const data = this.senaceService.getComponenteDerechoConsecion(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.codigo, item.fechaFormula, item.fechaVigente, item.nombre, item.situacion, item.titular];
        this.componenteDerechosConseciones.filas.push(...[arr]);
      });
    }
  }

  getComponenteEstudioPrevioAprobado(resultado) {
    const data = this.senaceService.getEstudioPrevioAprobado(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.entidad, item.escrito, item.fecha, item.proyecto, item.resolucionAprueba, item.tipoEstudio];
        this.componenteEstudioPrevioAprobado.filas.push(...[arr]);
      });
    }
  }
  getComponentePermisoVigente(resultado) {
    const data = this.senaceService.getPermisosVigentes(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.descripcion, item.entidad, item.fecha, item.numeroDocumento, item.tipoPermiso];
        this.componentePermisoVigente.filas.push(...[arr]);
      });
    }
  }
  getComponentePrincipal(resultado) {
    const data = this.senaceService.getComponentes(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.tipoComponente, item.componentePrincipal, item.NombreComponente, item.estado, item.areaOcupada];
        this.componentePrincipal.filas.push(...[arr]);
      });
    }
  }
  getComponenteEmpleo(resultado) {
    let data = this.senaceService.getEmpleos(resultado);
    if (!data) {
      data = this.senaceService.getPersonal(resultado);
    }
    if (data) {
      data.forEach(item => {
        let arr = [item.etapa, item.tipoEmpleo, item.cantidadTotal, item.calificada, item.noCalificada, item.porcentajeHombres, item.porcentajeLocal, item.porcentajeMujeres, item.porcentajeForaneo];
        this.componenteEmpleo.filas.push(...[arr]);
      });
    }
  }
  getComponenteInsumo(resultado) {
    const data = this.senaceService.getInsumos(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.insumo, item.cantidad, item.frecuencia, item.unidadMedida];
        this.componenteInsumo.filas.push(...[arr]);
      });
    }
  }
  getComponenteUsoAgua(resultado) {
    const data = this.senaceService.getusoAgua(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.nombreFuente, item.tipoUso, item.descripcion, item.consumoActual, item.numeroDias, item.total, item.fuenteAbastecimiento, item.norte, item.este, item.zona];
        this.componenteUsoAgua.filas.push(...[arr]);
      });
    }
  }
  getComponenteEfluente(resultado) {
    const data = this.senaceService.getEfluentes(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.codificacion, item.descripcion, item.este, item.norte, item.zona, item.caudal, item.accesibilidad, item.unidadMedida, item.frecuencia];
        this.componenteEfluentes.filas.push(...[arr]);
      });
    }
  }
  getComponenteResiduosAExtraer(resultado) {
    const data = this.senaceService.getManejoResiduosAextraer(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.tipoRecurso, item.descripcion, item.recurso, item.cantidad, item.unidadMedida, item.frecuencia];
        this.componenteResiduosEExtraer.filas.push(...[arr]);
      });
    }
  }
  getComponenteResiduosGenerar(resultado) {
    const data = this.senaceService.getManejoResiduosAgenerar(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.clasificacion, item.tipoResiduo, item.unidadPeso, item.peso, item.frecuencia, item.volumen];
        this.componenteResiduosGenerar.filas.push(...[arr]);
      });
    }
  }
  getComponenteResiduosPeligrosos(resultado) {
    const data = this.senaceService.getManejoResiduosPeligrosos(resultado);
    if (data) {
      data.forEach(item => {
        // let arr = [item.tipoResiduo, item.almacenajeTemporal , item.cantidad, item.descripcion, item.observacion, item.empresaPrestadoraServicios, item.clasificacion];
        let arr = [item.tipoResiduo, item.almacenajeTemporal, item.comercializacion, item.reprovechamiento, item.minimizacion, item.manejoTotal, item.empresaComercializadora, item.empresaPrestadoraServicios, item.clasificacion];
        this.componenteManejoResiduosPeligrosos.filas.push(...[arr]);
      });
    }
  }
  getComponenteTratamientoResiduosPeligrosos(resultado) {
    const data = this.senaceService.getTratamientoResiduosPeligrosos(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.tipoResiduo, item.cantidad, item.descripcion, item.observacion, item.empresaPrestadoraServicios, item.clasificacion];
        this.componenteTratamientoResiduosPeligrosos.filas.push(...[arr]);
      });
    }
  }
  getComponenteRecursoNatural(resultado): void {
    const data = this.senaceService.getRecursosNaturales(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.cantidad, item.descripcion, item.frecuencia, item.recursoNatural, item.unidadMedida];
        this.componenteRecursosNaturales.filas.push(...[arr]);
      });
    }
  }
  getComponenteEtapasProyecto(resultado): void {
    let data = this.senaceService.getEtapasProyecto(resultado);
    if (data) {
      if (data.caracteristicas) {
        data.caracteristicas.forEach(item => {
          let arr = [item.etapas, item.descripcion, item.mesInicio, item.mesFin, item.totalMeses];
          this.componenteEtapasProyecto.filas.push(...[arr]);
        });
      }
    } else {
      data = this.senaceService.getEtapasDeProyecto(resultado);
      if (data) {
        data.forEach(item => {
          let arr = [item.etapa, item.actividad, item.mesInicio, item.mesFin, item.total];
          this.componenteEtapasProyecto.filas.push(...[arr]);
        });
      }
    }
  }
  getComponenteSuperficies(resultado): void {
    let data = this.senaceService.getSuperficies(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.titularidad, item.superficieHa, item.situacionPredio, item.destino];
        this.componenteSuperficies.filas.push(...[arr]);
      });
    } else {
      data = this.senaceService.getSuperficiesOtros(resultado);
      if (data) {
        data.forEach(item => {
          let arr = [item.titular, item.superficie, item.situacionPredio, item.destino];
          this.componenteSuperficies.filas.push(...[arr]);
        });
      }
    }
  }
  getAntecedentesIGA(resultado): void {
    const data = this.senaceService.getAtecedentesIGA(resultado);
    if (data) {
      data.forEach(item => {
        let arr = [item.tipoIGA, item.resolucion, item.fechaRD];
        this.componenteAntecedentes.filas.push(...[arr]);
      });
    }
  }





}
